import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
var ɵ0 = adapterFactory;
var CalendarModule = /** @class */ (function () {
    function CalendarModule() {
    }
    return CalendarModule;
}());
export { CalendarModule };
export { ɵ0 };
